import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Loader';
import Message from '../Message';
import {
  getChapterDonations,
  markDonationPaid,
} from '../../actions/chapterActions';
import RTable from '../Table/RTable';
import ColumnFilter from '../Table/ColumnFilter';
import { Button, Card, Col, Row } from 'react-bootstrap';
import Moment from 'react-moment';
import AddDonation from './AddDonation';
import { DONATION_MARK_PAID_RESET } from '../../constants/chapterConstants';

const Donations = ({ donationTypes }) => {
  const dispatch = useDispatch();
  const [columnsAllDonations, setColumnsAllDonations] = useState([]);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const chapterDonationAll = useSelector((state) => state.chapterDonationAll);
  const {
    loading: chapterDonationAllLoading,
    error: chapterDonationAllError,
    allDonations,
  } = chapterDonationAll;

  const donationMarkPaid = useSelector((state) => state.donationMarkPaid);
  const { success: markPaidSuccess, error: markPaidError } = donationMarkPaid;

  const checkChapter = window.location.host;

  // Refresh the listing once a pending donation is confirmed so its status
  // flips from pending to paid.
  useEffect(() => {
    if (markPaidSuccess) {
      dispatch({ type: DONATION_MARK_PAID_RESET });
      dispatch(getChapterDonations(checkChapter));
    }
  }, [dispatch, checkChapter, markPaidSuccess]);

  useEffect(() => {
    if (
      (userInfo && userInfo.userRole === 'admin') ||
      userInfo.userRole === 'systemAdmin'
    ) {
      dispatch(getChapterDonations(checkChapter));

      setColumnsAllDonations([
        {
          Header: 'No.',
          accessor: (row, i) => i + 1,
        },
        {
          Header: 'Donation Type',
          accessor: 'donationType',
          Filter: ColumnFilter,
        },

        {
          Header: 'Amount',
          accessor: 'amount',
          Filter: ColumnFilter,
        },
        {
          Header: 'Date',
          accessor: 'donationDate',
          Filter: ColumnFilter,
          Cell: ({ value }) => {
            return <Moment>{value}</Moment>;
          },
        },

        {
          Header: 'Member Id',
          accessor: 'memberId',
          Filter: ColumnFilter,
        },

        {
          Header: 'First Name',
          accessor: 'firstName',
          Filter: ColumnFilter,
        },
        {
          Header: 'Last Name',
          accessor: 'lastName',
          Filter: ColumnFilter,
        },
        {
          Header: 'Email',
          accessor: 'email',
          Filter: ColumnFilter,
        },

        {
          Header: 'Member?',
          accessor: 'isMember',
          Filter: ColumnFilter,
          Cell: ({ value }) => {
            if (value) {
              return 'Yes';
            } else {
              return 'No';
            }
          },
        },
        {
          Header: 'Chapter',
          accessor: 'subDomain',
          Filter: ColumnFilter,
        },
        {
          Header: 'Payment Status',
          accessor: 'paymentStatus',
          Filter: ColumnFilter,
        },
        {
          // Zelle rows store "zelle" in payerId (the reference lands in
          // paymentId), matching how the event report derives its method.
          Header: 'Method',
          accessor: (row) =>
            row.payerId === 'zelle' ? 'zelle' : row.payerId ? 'paypal' : 'n/a',
          id: 'method',
          Filter: ColumnFilter,
        },
        {
          Header: 'Reference',
          accessor: 'paymentId',
          Filter: ColumnFilter,
        },
        {
          Header: 'Action',
          accessor: 'action',
          disableFilters: true,
          Cell: ({ row }) =>
            row.original.paymentStatus === 'pending' ? (
              <Button
                size='sm'
                variant='outline-success'
                onClick={() =>
                  dispatch(
                    markDonationPaid(
                      row.original.email,
                      row.original.donationDate
                    )
                  )
                }
              >
                Mark Paid
              </Button>
            ) : (
              <span className='text-muted'>—</span>
            ),
        },
      ]);
    }
  }, [dispatch, userInfo, checkChapter]);

  return (
    <Card>
      <Card.Header as='h3' className='text-info text-center'>
        <Row>
          <Col className='mr-auto'>DONATIONS</Col>
          <Col className='ml-auto' md={2} xs={4}>
            <AddDonation types={donationTypes} />
          </Col>
        </Row>
      </Card.Header>
      {chapterDonationAllLoading ? (
        <Loader />
      ) : chapterDonationAllError ? (
        <Message variant='danger'>{chapterDonationAllError}</Message>
      ) : (
        <>
          {markPaidError && <Message variant='danger'>{markPaidError}</Message>}
          {allDonations && allDonations.length !== 0 && (
            <RTable users={allDonations} COLUMNS={columnsAllDonations} />
          )}
        </>
      )}
    </Card>
  );
};

export default Donations;
